// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"de4516f7","453":"2ad95c70","455":"ad576670"}[chunkId] + ".chunk.js";
};